import { FileItem } from '../types/files';
import { fileSystemService } from '../services/fileSystem';

export async function readFileTree(dirPath: string): Promise<FileItem[]> {
  const items = await fileSystemService.readDirectory(dirPath);

  const results = await Promise.all(items.map(async (item): Promise<FileItem> => {
    if (item.isDirectory) {
      const children = await readFileTree(item.path);
      return { ...item, children };
    } else {
      return { ...item, children: null };
    }
  }));

  return results;
}

export function isSameFlatFileTree(a: FileItem[], b: FileItem[]): boolean {
  if (a.length !== b.length) return false;

  const sortByPath = (arr: FileItem[]) =>
    [...arr].sort((x, y) => x.path.localeCompare(y.path));

  const sortedA = sortByPath(a);
  const sortedB = sortByPath(b);

  return sortedA.every((item, index) => {
    const other = sortedB[index];
    return (
      item.path === other.path &&
      item.name === other.name &&
      item.isDirectory === other.isDirectory
    );
  });
}

export function resolveVirtualToAbsolute(
  projectRootPath: string,
  sessionId: string,
  virtualPath: string
) {
  const prefix = sessionId + "\\";
  const relative = virtualPath.startsWith(prefix)
    ? virtualPath.slice(prefix.length)
    : virtualPath;

  return projectRootPath.replace(/\\+$/, "") + "\\" + relative;
}

export function assertRealPath(
  path: string | null,
  virtualPath: string
): asserts path is string {
  if (!path) {
    throw new Error(`Real path not found for virtual path: ${virtualPath}`);
  }
}